export const checkUrl = (url: string) => {
  const expression =
    /^(https?:\/\/)[-a-zA-Z0-9@:%._\\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)?/gi;
  const regex = new RegExp(expression);

  if (url.match(regex)) return true;
  return false;
};

export const checkLetterText = (url: string) => {
  const expression = /^[a-zA-Z]+$/;
  const regex = new RegExp(expression);

  if (url.match(regex)) return true;
  return false;
};

export const checkFloatText = (text: string, allowNegative = true, maxDecimal = 2) => {
  if (maxDecimal < 0) {
    maxDecimal = 0;
  }
  const expression = allowNegative
    ? `^[+-]?(\\d+)?((\\.|,)\\d{0,${maxDecimal}})?$`
    : `^(\\d+)?((\\.|,)\\d{0,${maxDecimal}})?$`;
  const regex = new RegExp(expression);
  if (text.match(regex)) return true;
  return false;
};

/**
 * Check if a string contains emojis
 * @param text text to analyze
 * @returns boolean
 */
export const hasEmoji = (text: string) => {
  const withEmojis = /\p{Extended_Pictographic}/gu;
  return withEmojis.test(text);
};

/**
 * Standard GSM characters
 * @param text
 * @returns
 */
export const hasOnlyGSMCharacter = (text: string) => {
  const allowedCharacters =
    /^[!"#$%'()*,/:;<=>?@_¡£¥§¿&¤A-Za-z0-9Ä Å Æ Ç É Ñ Ø ø Ü ß Ö à ä å æ è é ì ñ ò ö ù ü Δ Φ Γ Λ Ω Π Ψ Σ Θ Ξ+\-()./\n]+$/;
  return allowedCharacters.test(text);
};

/**
 * Indicates if text should use unicode format for SMS
 * @param text
 * @returns
 */
export const isUnicodeText = (text: string) => {
  return hasEmoji(text) || !hasOnlyGSMCharacter(text);
};

/**
 * Check if a string is a valid email
 * @param email email to analyze
 * @returns boolean
 */
export const isEmail = (email: string) => {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(email);
};

/**
 * Check if the browser is Safari on Mac
 * @param userAgent user agent
 * @returns boolean
 */
export const isSafariOnMac = (userAgent: string) => {
  const isMac = /Macintosh/.test(userAgent);
  const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);

  return isMac && isSafari;
};
